import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './JobListViewEmptyState.scss';

const propTypes = {
  addJobsToModelClick: PropTypes.func
};

const JobListViewEmptyState = props => {
  return (
    <div className="jobListView-empty-state-container">
      <img className="jobListView-empty-state--icon" src="/view/static/mp/images/job.svg" />
      <h1 className="heading--jobListView-empty">No jobs have been added to this model</h1>
      <h3 className="subheading--jobListView-empty">Add some jobs to start building your model</h3>
      <button className="pxl-btn pxl-btn-default" onClick={props.addJobsToModelClick}>
        Add Jobs to Model
      </button>
    </div>
  );
};

JobListViewEmptyState.propTypes = propTypes;

export default JobListViewEmptyState;
